import React from 'react';
import {
  CheckCircle,
  Clock,
  Calendar,
  Users,
  Rocket,
  BarChart,
  Shield,
  Globe,
  ArrowRight
} from 'lucide-react';

const Demo = () => {
  const benefits = [
    {
      icon: <Clock className="w-6 h-6 text-blue-500" />,
      title: "Save Time",
      description: "Reduce your hiring time by up to 75% with our AI-powered screening"
    },
    {
      icon: <BarChart className="w-6 h-6 text-blue-500" />,
      title: "Better Matches",
      description: "Find candidates that perfectly match your requirements using advanced algorithms"
    },
    {
      icon: <Shield className="w-6 h-6 text-blue-500" />,
      title: "Reduce Bias",
      description: "Ensure fair hiring practices with our bias-detection technology"
    },
    {
      icon: <Globe className="w-6 h-6 text-blue-500" />,
      title: "Global Reach",
      description: "Access talent from anywhere in the world with our global platform"
    }
  ];

  const handleSub = async (e) => {
    e.preventDefault();
  
    const formData = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      company: e.target.company.value,
      jobTitle: e.target.jobTitle.value,
      companySize: e.target.companySize.value,
      interest: e.target.interest.value,
    };
  
    try {
      const response = await fetch("https://5odmedb123.execute-api.ap-south-1.amazonaws.com/prod/requestDemo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        alert("Demo request submitted successfully!");
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again later.");
    }
  };
  

  return (
    <div className="pt-16">
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700 opacity-90" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center text-white">
            <h1 className="text-4xl font-extrabold sm:text-5xl lg:text-6xl">
              Transform Your Hiring Process
            </h1>
            <p className="mt-6 text-xl max-w-3xl mx-auto">
              See how our AI-powered platform can revolutionize your recruitment workflow with a personalized demo.
            </p>
          </div>
        </div>
      </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Why Choose Our Platform?</h2>
          <p className="mt-4 text-lg text-gray-600">
            Join thousands of companies that have transformed their hiring process
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex flex-col items-center text-center">
                <div className="mb-4 p-3 bg-blue-50 rounded-full">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Demo Request Form */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900">Request Your Demo</h2>
              <p className="mt-4 text-lg text-gray-600">
                Fill out the form below and one of our product specialists will contact you shortly.
              </p>
            </div>
            
            <form onSubmit={handleSub} className="space-y-6">
  <div className="grid md:grid-cols-2 gap-6">
    <div>
      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
        First Name
      </label>
      <input
        id="firstName"
        name="firstName" // Add this
        type="text"
        required
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>
    <div>
      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
        Last Name
      </label>
      <input
        id="lastName"
        name="lastName" // Add this
        type="text"
        required
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>
  </div>

  <div>
    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
      Work Email
    </label>
    <input
      id="email"
      name="email" // Add this
      type="email"
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>

  <div>
    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
      Company
    </label>
    <input
      id="company"
      name="company" // Add this
      type="text"
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>

  <div>
    <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700 mb-2">
      Job Title
    </label>
    <input
      id="jobTitle"
      name="jobTitle" // Add this
      type="text"
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>

  <div>
    <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 mb-2">
      Company Size
    </label>
    <select
      id="companySize"
      name="companySize" // Add this
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
      <option value="">Select company size</option>
      <option value="1-50">1-50 employees</option>
      <option value="51-200">51-200 employees</option>
      <option value="201-500">201-500 employees</option>
      <option value="501-1000">501-1000 employees</option>
      <option value="1000+">1000+ employees</option>
    </select>
  </div>

  <div>
    <label htmlFor="interest" className="block text-sm font-medium text-gray-700 mb-2">
      What interests you most about our platform?
    </label>
    <textarea
      id="interest"
      name="interest" // Add this
      rows={4}
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    ></textarea>
  </div>

  <div>
    <button
      type="submit"
      className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      Request Demo
      <ArrowRight className="w-4 h-4 ml-2 inline-block" />
    </button>
  </div>
</form>
          </div>
        </div>
      </div>

      {/* Social Proof Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Trusted by Industry Leaders</h2>
          <p className="mt-4 text-lg text-gray-600">
            Join hundreds of companies already transforming their hiring process
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-xl p-6">
            <p className="text-gray-600 mb-4">
              "This platform has completely transformed our hiring process. We've reduced our time-to-hire by 60% while finding better candidates."
            </p>
            <div className="flex items-center">
              <img
                src="/api/placeholder/48/48"
                alt="Testimonial author"
                className="rounded-full"
              />
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Sarah Thompson</p>
                <p className="text-sm text-gray-500">HR Director, Tech Corp</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-6">
            <p className="text-gray-600 mb-4">
              "The AI-powered screening has been a game-changer for us. We're now able to process applications much faster and more accurately."
            </p>
            <div className="flex items-center">
              <img
                src="/api/placeholder/48/48"
                alt="Testimonial author"
                className="rounded-full"
              />
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Michael Chen</p>
                <p className="text-sm text-gray-500">Talent Lead, Innovation Inc</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-6">
            <p className="text-gray-600 mb-4">
              "The platform's analytics have given us incredible insights into our hiring process. We're now making data-driven decisions."
            </p>
            <div className="flex items-center">
              <img
                src="/api/placeholder/48/48"
                alt="Testimonial author"
                className="rounded-full"
              />
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Emma Rodriguez</p>
                <p className="text-sm text-gray-500">COO, Global Solutions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;